module.exports = __webpack_public_path__ + "static/img/head-illustration.4166686b.jpg";